module.exports = __webpack_public_path__ + "img/manchester.87ed9189.png";